"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBoxPlotStatistics = void 0;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const checks_1 = require("./checks");
/** Linear-interpolation quantile of a sorted array of numbers (0 <= p <= 1) */
const quantile = (sorted, p) => {
    const index = (sorted.length - 1) * p;
    const lower = Math.floor(index);
    const upper = Math.ceil(index);
    if (lower === upper)
        return sorted[lower];
    return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower);
};
/** Calculates min, quartiles and max (for a box plot) from an array of measurement results */
const getBoxPlotStatistics = (values) => {
    const sorted = values.filter(checks_1.isNumber).sort((a, b) => a - b);
    if (!sorted.length)
        return undefined;
    return {
        min: sorted[0],
        q1: quantile(sorted, 0.25),
        median: quantile(sorted, 0.5),
        q3: quantile(sorted, 0.75),
        max: sorted[sorted.length - 1],
    };
};
exports.getBoxPlotStatistics = getBoxPlotStatistics;
//# sourceMappingURL=boxPlot.js.map